import classNames from 'classnames/bind';
import { useState } from 'react';
import { ChevronRight, Exit, kgLogoDev, kgLogo as kgLogoProd, kgLogoStage, Menu } from '../../assets/icons/Icons';
import { useConfig, useUser } from '../../context/PortalContext/PortalContext';
import Avatar from '../Avatar/Avatar';
import Styles from './navigation.module.scss';
import { getPortalItems } from './utils/portalNavUtils';

const cx = classNames.bind(Styles);

type Props = {
  currentApp: string;
};

const Navigation = ({ currentApp }: Props) => {
  const [isOpen, setIsOpen] = useState(false);
  const user = useUser();
  const config = useConfig();

  if (!config || !config.urls) {
    return <></>;
  }

  const homeLink = config?.urls?.portal;
  const items = getPortalItems(config.urls, user.details, currentApp?.toLowerCase());

  const logoutUrl = config.urls.logoutUrl;
  const prevLocation = encodeURI(window.location.href);
  const logoutLink = logoutUrl ? encodeURI(`${logoutUrl}?returnUrl=${prevLocation}`) : logoutUrl;
  const env = process.env.NODE_ENV;
  const envClass = env === 'development' ? 'dev' : env === 'staging' ? 'stage' : '';

  const generateNavItem = (item, index) => {
    return (
      <li key={index} className={cx('item-wrapper', { 'item-wrapper-selected': item.selected })}>
        <div className={cx('item')}>
          <a className={cx('item', 'item-content')} href={item.href} target={item.target} rel={item.rel}>
            <div className={cx('icon', envClass)}>{item.icon}</div>
            <div className={cx('label')}>{item.label}</div>
            <div className={cx('mobile-arrow')}>{ChevronRight}</div>
          </a>
        </div>
      </li>
    );
  };

  let kgLogo = kgLogoProd;
  if (env === 'development') {
    kgLogo = kgLogoDev;
  } else if (env === 'staging') {
    kgLogo = kgLogoStage;
  }

  return (
    <nav className={cx('sidebar', { 'sidebar-open': isOpen })} role='navigation'>
      <ul className={cx('sidebar-header')}>
        <li className={cx('sidebar-header', { 'sidebar-header-open': isOpen })}>
          <a href={homeLink} aria-label='return home' className={cx('logo')}>
            <div className={cx(envClass)}>{kgLogo}</div>
          </a>
          <div className={cx('burger-view')}>
            <button
              className={cx('burger-container', { 'burger-container-open': isOpen })}
              onClick={() => setIsOpen(!isOpen)}
              aria-label={isOpen ? 'Close Nav' : 'Open Nav'}>
              <span className={cx('burger-label', { 'burger-label-open': isOpen })}>
                {isOpen ? <span className={cx('exit-button')}>{Exit}</span> : Menu}
              </span>
            </button>
          </div>
        </li>
      </ul>
      <ul className={cx('nav-wrapper', { 'nav-wrapper-open': isOpen })}>
        <li className={cx('item-wrapper', 'item-wrapper-mobile')}>
          <div className={cx('item', 'item-content', 'item-avatar', 'avatar')}>
            <Avatar />
          </div>
        </li>
        {items.map((item, index) => generateNavItem(item, index))}
        <li className={cx('item-wrapper', 'item-wrapper-mobile')}>
          <div className={cx('item')}>
            <a className={cx('item', 'item-content')} href={logoutLink}>
              <div className={cx('label')}>Log Out</div>
            </a>
          </div>
        </li>
      </ul>
    </nav>
  );
};

export default Navigation;
